interface PlaceholderProps {
  title: string;
  blurb: string;
  increment: string;
}

export function Placeholder({ title, blurb, increment }: PlaceholderProps) {
  return (
    <div style={{ maxWidth: 720 }}>
      <div
        style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 11,
          letterSpacing: '0.2em',
          color: '#00E87A',
          textTransform: 'uppercase',
          marginBottom: 10,
        }}
      >
        {increment}
      </div>
      <h1
        style={{
          fontFamily: "'Syne', sans-serif",
          fontSize: 32,
          fontWeight: 800,
          marginBottom: 12,
        }}
      >
        {title}
      </h1>
      <p style={{ color: '#B8BDD6', fontSize: 14, lineHeight: 1.7 }}>{blurb}</p>
    </div>
  );
}
